import { Routes } from '@angular/router';
import {
    CartsumComponent,
    CartsummaryComponent,
    ContactComponent,
    ForgotpasswordComponent,
    IntroductionComponent,
    MyOrdersComponent,
    OrderConfirmationComponent,
    PaymentStatusComponent,
    PersonalDataComponent,
    SigninComponent,
    SignupComponent,
    TypeofdeliveryComponent,
    TypeofpaymentComponent,
    UnsubscribeComponent,
    VerificationComponent,
    VerificationForgotPasswordComponent,
    VerificationForgotpasswordMessageComponent,
    VerificationMessageComponent
} from '@prekog/common-ui';
import { BlogComponent } from './blog/blog.component';
import { BlogListComponent } from './bloglist/bloglist.component';
import { BooksComponent } from './books/books.component';
import { BooksByCategoryComponent } from './booksbycategory/booksbycategory.component';
import { HomeComponent } from './home/home.component';
import { PackageProductsComponent } from './packageproducts/package-products.component';
import { AllProductsComponent } from './allproducts/all-products.component';
import { SpecialofferComponent } from './shared/components/specialoffer/specialoffer.component';

export const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'book', component: AllProductsComponent },
    { path: 'book/:routerLink', component: BooksComponent },
    { path: 'blog', component: BlogListComponent },
    { path: 'introduction', component: IntroductionComponent },
    { path: 'blog/:routerLink', component: BlogComponent },
    { path: 'cartsum', component: CartsumComponent },
    { path: 'cartsummary', component: CartsummaryComponent },
    { path: 'delivery', component: TypeofdeliveryComponent },
    { path: 'payment', component: TypeofpaymentComponent },
    { path: 'orderconfirmation', component: OrderConfirmationComponent },
    { path: 'paymentstatus', component: PaymentStatusComponent },
    { path: 'contact', component: ContactComponent },
    { path: 'signin', component: SigninComponent },
    { path: 'signup', component: SignupComponent },
    { path: 'forgotpassword', component: ForgotpasswordComponent },
    { path: 'verification/:id', component: VerificationComponent },
    { path: 'verification-forgotpassword/:id', component: VerificationForgotPasswordComponent },
    { path: 'verificationmessage', component: VerificationMessageComponent },
    { path: 'verificationforgotpasswordmessage', component: VerificationForgotpasswordMessageComponent },
    { path: 'specialoffer', component: SpecialofferComponent },
    { path: 'specialoffer/:routerLink', component: PackageProductsComponent },
    { path: 'personaldata', component: PersonalDataComponent },
    { path: 'myorders', component: MyOrdersComponent },
    { path: 'category/:name/:id', component: BooksByCategoryComponent },
    { path: 'unsubscribe/:email', component: UnsubscribeComponent }
];
